module.exports = __webpack_public_path__ + "static/media/successImg.fe1d14f9.gif";